var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 3.23933C9.57125 3.06058 7.75667 2.9685 5.9475 2.9685C4.875 2.9685 3.8025 3.02266 2.73 3.131L1.625 3.23933M4.60417 2.69225L4.72333 1.98266C4.81 1.46808 4.875 1.0835 5.79042 1.0835H7.20958C8.125 1.0835 8.19542 1.48975 8.27667 1.98808L8.39583 2.69225M10.2104 4.951L9.85833 10.4056C9.79875 11.256 9.75 11.9168 8.23875 11.9168H4.76125C3.25 11.9168 3.20125 11.256 3.14167 10.4056L2.78958 4.951M5.59542 8.93766H7.39917M5.14583 6.771H7.85417",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.49072188ea2f1f309b9980283368b161.svg";
export { ForwardRef as ReactComponent };